import { useLivenessRegisterMachine } from '../components/machine-provider';

export default useLivenessRegisterMachine;
